export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_ms.84e52d85fd343d4c.json"